module.exports = __webpack_public_path__ + "img/cashPay.9fb1ef75.svg";